var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCarouselArrowLeft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 26,
    viewBox: "0 0 9 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.495 0.911821C7.71679 1.02322 7.88535 1.21802 7.96373 1.45352C8.04211 1.68901 8.02391 1.94598 7.91312 2.16807L2.5 12.9999L7.915 23.8299C7.97128 23.9401 8.0052 24.0604 8.0148 24.1837C8.0244 24.3071 8.00949 24.4311 7.97092 24.5487C7.93235 24.6662 7.8709 24.775 7.7901 24.8687C7.7093 24.9624 7.61075 25.0392 7.50014 25.0946C7.38953 25.15 7.26903 25.183 7.14561 25.1916C7.02219 25.2003 6.89827 25.1844 6.78102 25.1449C6.66376 25.1055 6.55547 25.0432 6.4624 24.9616C6.36933 24.8801 6.29332 24.781 6.23875 24.6699L0.613748 13.4199C0.54842 13.2896 0.514404 13.1458 0.514404 12.9999C0.514404 12.8541 0.54842 12.7103 0.613748 12.5799L6.23875 1.32995C6.35015 1.10816 6.54495 0.939591 6.78045 0.86121C7.01594 0.782829 7.2729 0.80103 7.495 0.911821Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarouselArrowLeft);
export default __webpack_public_path__ + "static/media/carousel-arrow-left.62710494d6a5002de69b85b367225d54.svg";
export { ForwardRef as ReactComponent };